module.exports = __webpack_public_path__ + "static/media/stage2New.f88e370f.png";